import Gator from 'gator';

Gator(_gg.html).on('click', '.press .press-tab', function() {
    const key = this.getAttribute('data-key');

    // manage tabs
    const tabs = document.querySelectorAll('.press .press-tab');
    tabs.forEach(tab => {
        tab.classList.remove('active');
    });
    this.classList.add('active');

    // manage galleries
    const galleries = document.querySelectorAll('.press .press-gallery');
    galleries.forEach(gallery => {
        gallery.classList.remove('active');
    });
    document.querySelector(`.press .press-gallery[data-key="${key}"]`).classList.add('active');
});
